export default __webpack_public_path__ + "static/media/user-jenny.476342eb.png";